<template>
    <v-container fluid>
        <v-row justify="center" class="mt-6">
            <v-btn @click="doctor_dialog_title='新增醫師'; new_doctor()" large color="primary" class="ml-3 mt-1" style="height: 46px; font-size: 18px;">新增醫師</v-btn>
            <v-text-field v-model="search_text" single-line="" class="input_600 ml-3" placeholder="搜尋" append-icon="mdi-magnify" outlined></v-text-field>
            <!-- <v-btn large color="success" class="ml-3 mt-1" style="height: 46px; font-size: 18px;">搜尋</v-btn> -->
        </v-row>

        <v-row justify="center" class="">
            <v-col cols="12" sm="6">
                <v-data-table :headers="headers" :items="table_data" :search="search_text" class="elevation-1">
                    <template v-slot:item.index="{ item }">
                        {{table_data.findIndex(items => { return items.name == item.name})+1}}
                    </template>
                    <template v-slot:item.set="{item}">
                        <v-btn @click="doctor_dialog_title='編輯醫師'; edit_doctor(item)" class="ml-3" color="primary">修改</v-btn>
                        <v-btn @click="open_delete_vendor(item.name)" class="ml-3" color="error">刪除</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-if="doctor_dialog == true" v-model="doctor_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">{{doctor_dialog_title}}
                    <v-spacer/>
                    <v-icon @click="doctor_dialog=false; init_doctor_data();">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-text-field v-model="doctor_data.name" label="醫生名稱:" :rules="[rules.doctorName]" outlined></v-text-field>
                    <v-select 
                        v-model="doctor_data.vendor_id" 
                        label="隸屬廠商名稱:" 
                        :items="vendor_list"
                        item-text="name"
                        item-value="id"
                        :rules="[rules.vendorName]" 
                        outlined
                        :disabled="edit_status == true">
                    </v-select>
                    <!-- <v-text-field v-model="doctor_data.vendorName" label="隸屬廠商名稱:" :rules="[rules.doctorName]" outlined></v-text-field> -->
                    <v-text-field v-model="doctor_data.account" label="帳號(請輸入e-mail):" :rules="accountRules" :disabled="edit_status==true" outlined></v-text-field>
                    <v-text-field 
                        v-model="doctor_data.password" 
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" 
                        :rules="[rules.required, rules.min, rules.charactor]"
                        type='password'
                        label="新密碼:" 
                        outlined
                    ></v-text-field>
                    <v-text-field 
                        v-model="doctor_data.password2" 
                        label="確認密碼:" 
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" 
                        :rules="[rules.required, rules.min, rules.same]"
                        type='password'
                        outlined></v-text-field>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click=" submit()" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_dialog" max-width="300px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">確定刪除{{delete_dialog_account}}?
                    <v-spacer/>
                    <v-icon @click="delete_dialog=false;">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions>        
                    <v-col>
                        <v-btn @click="delete_dialog = false;" block>取消</v-btn>
                    </v-col>   
                    <v-col>
                        <v-btn color="error" @click="delete_doctor(delete_index); delete_dialog = false;" block>確定</v-btn>       
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { get } from 'http'
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL 
export default {
    props:{
        vendor_id: {
            type: Number,
            default: -1
        }
    },
    data(){
        return {
            type_: "",
            search_text: "",
            page: 0,
            doctor_dialog_title: "",
            doctor_dialog: false,

            account_type: localStorage.getItem('account_type'),
            show1: true,
            show2: true,
            
            vendor_list: [],

            delete_dialog: false,
            delete_dialog_account: '',
            delete_index: '',

            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '名稱', align: 'center', value: 'name'},
                {text: '隸屬廠商名稱', align: 'center', value: 'source'},
                {text: '操作', align: 'center', value: 'set', width: 200, sortable: false},
            ],
            table_data: [],
            accountRules: [
                v => !!v || 'E-mail為必填',
                v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],
            rules: {
                doctorName: v => !!v || '醫生名稱必填',
                vendorName: v => !!v || '隸屬廠商必填',
                required: value => !!value || '必填',
                min: v => v.length >= 8 || '最少輸入8碼',
                same: v=> v == this.doctor_data.password || '密碼不一致'
            },
            doctor_data: {
                name: '',
                vendor_id: '',
                account: '',
                password: '',
                password2: ''
            },
            edit_status: '',
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            this.get_docotr()

            axios.get(host_url+'get_vendor_list/')
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.vendor_list = tmp.vendor_list
                    if(this.vendor_id != -1){
                        let v_list = this.vendor_list.find(item =>{ 
                            return item.id == this.vendor_id
                        })
                        this.vendor_list = v_list
                    }
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }

            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });

        },
        init_doctor_data(){
            this.doctor_data = {
                name: '',
                account: '',
                password: '',
                password2: ''
            }
        },
        get_docotr(){
            let vid = this.vendor_id
            // console.log(vid)
            
            let get_data_url = 'doctor_list/?vid='+String(vid)
            axios.get(host_url+get_data_url)
            .then(response => {
                var tmp = response.data
                
                if(tmp.status == true){
                    this.table_data = tmp.data
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }

            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        edit_doctor(item){
            this.doctor_dialog = true
            this.edit_status = true
            this.doctor_data.name = item.name
            this.doctor_data.account = item.email
            this.doctor_data.vendor_id = item.vendor_id
            this.doctor_data.account_id = item.account_id
        },
        new_doctor(){
            this.doctor_dialog = true
            this.edit_status = false
        },
        edit_doctor_click(){
            this.doctor_dialog = true
        },
        submit(){
            if(this.edit_status == false){
                let data = this.doctor_data
                if(data.name == ''){ bus.$emit('alert', {msg: "醫師名稱不能空白", title: "錯誤提示",　check: "我知道了"});  return; }
                if(this.checkEmail(data.account) == false){ bus.$emit('alert', {msg: "帳號不能空白, 且請輸入正確的email", title: "錯誤提示",　check: "我知道了"}); return; }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password) == false){
                        bus.$emit('alert', {msg: "密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); 
                        return; 
                    }                    
                }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password2)== false){
                        bus.$emit('alert', {msg: "確認密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); 
                        return; 
                    }                    
                }
                let type_ = 'doctor'
                bus.$emit('update', {msg: '新增中...'})
                axios.post(host_url+'api/account/', {'data': data, 'type': type_, 'vendor_id': this.doctor_data.vendor_id})
                .then(response => {
                    bus.$emit('close_update')
                    var tmp = response.data
                    if(tmp.status == true){
                        this.get_docotr()
                        bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                        this.doctor_dialog = false
                        this.init_doctor_data()

                        
                    }
                    else{
                        bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                    }
                })
                .catch((error) =>{
                    // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                    console.log(error);
                });
            }
            else{
                let type_ = 'doctor'
                let data = this.doctor_data
                if(data.name == ''){ bus.$emit('alert', {msg: "醫師名稱不能空白", title: "錯誤提示",　check: "我知道了"}); return; }
                if(this.checkEmail(data.account) == false){ bus.$emit('alert', {msg: "帳號不能空白, 且請輸入正確的email", title: "錯誤提示",　check: "我知道了"}); return; }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password) == false){
                        bus.$emit('alert', {msg: "密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); return; 
                    }                    
                }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password2)== false){
                        bus.$emit('alert', {msg: "確認密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); return; 
                    }                    
                }
                bus.$emit('update', {msg: '修改中...'})
                axios.post(host_url+'update_vendor/', {'data': data, 'type': type_, 'vendor_id': localStorage.getItem('vendor_id') })
                .then(response => {
                    bus.$emit('close_update')
                    var tmp = response.data
                    if(tmp.status == true){
                        this.table_data = tmp.data
                        this.doctor_dialog = false
                        
                        // console.log('success')
                        bus.$emit('alert', {msg: "修改成功!", title: "成功提示",　check: "我知道了"})
                        this.init_doctor_data()
                    }
                    else{
                        // console.log(tmp.msg)
                        bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                    }
                })
                .catch((error) =>{
                    // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                    console.log(error);
                });
            }
        },
         // 開啟刪除提醒
        open_delete_vendor(name){

            this.delete_dialog_account = name;
            this.delete_dialog = true;
            this.delete_index = this.table_data.findIndex(item => {
                return item.name == name;
            });
            // console.log(this.delete_index)
        },
        // 刪除醫生
        delete_doctor(idx){
            // console.log(this.table_data[idx])
            let data = this.table_data[idx]
            // console.log(data)
            axios.post(host_url+'delete_vendor/', {'data': data})
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.get_docotr()
                    // console.log('success')
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }

            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
            this.table_data.splice(idx, 1);
            
        },
        // 確認信箱格式
        checkEmail(val){
            const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (regexp.test(val)){ return true; }
            else { return false; }
        },
        // 確認密碼格式
        checkPassword(val){
            if(val == ''){ return false}
            if(val.length < 8){ return false}
            if(val != this.doctor_data.password){ return false}
        },

    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_200{
    max-width: 200px;
}

::v-deep .input_600{
    max-width: 600px;
}


</style>